module.exports = __webpack_public_path__ + "static/img/static_bg4.427958b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/static_bg4.png
// module id = hRlv
// module chunks = 37